import { type ThunkCtx, thunks } from "@app/api";
import { parallel } from "@app/fx";
import { fetchVpcPeersByStackId } from "./vpc-peer";
import { fetchVpnTunnelsByStackId } from "./vpn-tunnel";

export const fetchNetworkDataForPrintReport = thunks.create<{
  stackIds: string[];
}>("fetch-network-data-for-print-report", function* (ctx, next) {
  const { stackIds } = ctx.payload;
  const tasks = stackIds.flatMap((id) => [
    fetchVpcPeersByStackId.run({ id }),
    fetchVpnTunnelsByStackId.run({ id }),
  ]);
  if (tasks.length > 0) {
    const group = yield* parallel<ThunkCtx>(tasks);
    yield* group;
  }
  yield* next();
});
